<template>
    <VueSlickCarousel
        v-bind="settings"
        class="carousel-items__slider slider slider-carousel"
    >
        <div
            class="carousel-items__slider-item"
            v-for="sliderItem of sliderItems"
        >
            <img
                class="carousel-items__slider-item-img"
                :src="sliderItem.preview"
                :alt="sliderItem.name"
            />
            <a
                class="carousel-items__slider-item-name link _underline"
                :href="sliderItem.url"
            >
                <span>{{ sliderItem.name }}</span>
                <svg viewBox="0 0 13 20">
                    <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5" />
                </svg>
            </a>
            <span class="carousel-items__slider-item--price"
                >от {{ sliderItem.price }} руб.</span
            >
            <p
                class="carousel-items__slider-item--text"
                v-html="sliderItem.text"
            ></p>
            <a class="carousel-items__slider-item--link" :href="sliderItem.url"
                >Читать далее</a
            >
        </div>

        <template #prevArrow="arrowOption">
            <button type="button" class="slick-arrow _prev">
                <svg class="icon-arrow">
                    <use xlink:href="#arrow-slider" />
                </svg>
            </button>
        </template>

        <template #nextArrow="arrowOption">
            <button type="button" class="slick-arrow _next">
                <svg class="icon-arrow">
                    <use xlink:href="#arrow-slider" />
                </svg>
            </button>
        </template>
    </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

export default {
    name: 'carouselItems',
    components: { VueSlickCarousel },
    mounted() {
        this.$http.get('/api/products/related').then((res) => {
            this.sliderItems = res.data;
        });
    },
    data() {
        return {
            settings: {
                arrows: true,
                infinite: true,
                slidesToScroll: 4,
                slidesToShow: 4,
                lazyLoad: 'ondemand',
                responsive: [
                    {
                        breakpoint: 1240,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 994,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            autoplay: true,
                            autoplaySpeed: 10000,
                            dots: true,
                        },
                    },
                ],
            },
            sliderItems: [
                {
                    name: 'Миникассетная система',
                    text: 'это разновидность рулонных жалюзи, которые устанавливаются непосредственно на&nbsp;створку окна.',
                    price: '2934',
                    imgSrc: '/assets/img/index/carousel-items-5.jpg',
                    itemLink: '#',
                },
                {
                    name: 'Плиссе',
                    text: 'это разновидность рулонных жалюзи, которые устанавливаются непосредственно на&nbsp;створку окна.',
                    price: '2934',
                    imgSrc: '/assets/img/index/carousel-items-2.jpg',
                    itemLink: '#',
                },
                {
                    name: 'Миникассетная система',
                    text: 'это разновидность рулонных жалюзи, которые устанавливаются непосредственно на&nbsp;створку окна.',
                    price: '2934',
                    imgSrc: '/assets/img/index/carousel-items-3.jpg',
                    itemLink: '#',
                },
                {
                    name: 'Плиссе',
                    text: 'это разновидность рулонных жалюзи, которые устанавливаются непосредственно на&nbsp;створку окна.',
                    price: '2934',
                    imgSrc: '/assets/img/index/carousel-items-4.jpg',
                    itemLink: '#',
                },
                {
                    name: 'Миникассетная система',
                    text: 'это разновидность рулонных жалюзи, которые устанавливаются непосредственно на&nbsp;створку окна.',
                    price: '2934',
                    imgSrc: '/assets/img/index/carousel-items-5.jpg',
                    itemLink: '#',
                },
                {
                    name: 'Плиссе',
                    text: 'это разновидность рулонных жалюзи, которые устанавливаются непосредственно на&nbsp;створку окна.',
                    price: '2934',
                    imgSrc: '/assets/img/index/carousel-items-2.jpg',
                    itemLink: '#',
                },
            ],
        };
    },
};
</script>
